import axios from 'axios';
import { getAuthHeader } from './otpAuthService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export interface CreatePaymentIntentResponse {
  success: boolean;
  clientSecret: string;
  paymentIntentId: string;
  amount: number;
  years: number[];
  yearsFormatted: string;
}

export interface ConfirmPaymentRequest {
  paymentIntentId: string;
}

export interface Receipt {
  receiptNumber: string;
  amount: number;
  year: number;
  issueDate: string;
  receiptId: string;
}

export interface ConfirmPaymentResponse {
  success: boolean;
  message: string;
  receipt: Receipt;
}

/**
 * Crea un Payment Intent per il pagamento della quota
 * Gli anni e l'importo vengono letti dalle impostazioni globali configurate dall'admin
 */
export const createPaymentIntent = async (): Promise<CreatePaymentIntentResponse> => {
  const response = await axios.post<CreatePaymentIntentResponse>(
    `${API_BASE_URL}/payment/create-payment-intent`,
    {}, // Nessun body, usa settings globali
    { headers: getAuthHeader() as any }
  );
  return response.data;
};

/**
 * Conferma il pagamento dopo che Stripe ha processato la transazione
 */
export const confirmPayment = async (paymentIntentId: string): Promise<ConfirmPaymentResponse> => {
  const response = await axios.post<ConfirmPaymentResponse>(
    `${API_BASE_URL}/payment/confirm-payment`,
    { paymentIntentId },
    { headers: getAuthHeader() as any }
  );
  return response.data;
};

/**
 * Scarica la ricevuta PDF
 */
export const downloadReceipt = async (receiptId: string): Promise<void> => {
  const response = await axios.get(
    `${API_BASE_URL}/payment/receipt/${receiptId}/pdf`,
    {
      headers: getAuthHeader() as any,
      responseType: 'blob'
    }
  );

  // Crea un link temporaneo per il download
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;

  // Estrai il nome del file dall'header Content-Disposition se disponibile
  const contentDisposition = response.headers['content-disposition'];
  let filename = 'Ricevuta_UNASCA.pdf';

  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
    if (filenameMatch && filenameMatch[1]) {
      filename = filenameMatch[1];
    }
  }

  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
